// extracted by mini-css-extract-plugin
export default {"tableBodyContainer":"ReactTable-module__tableBodyContainer--aeYvr"};